import { IBaseModel } from "../BaseModel";

export enum IntegrationService {
  Telleroo,
  Ebay,
}

export const IntegrationServiceLookup: Record<IntegrationService, string> = {
  [IntegrationService.Telleroo]: "Telleroo",
  [IntegrationService.Ebay]: "Ebay",
};

export interface ICustomerIntegration extends IBaseModel {
  userId: string;
  customerId: string;
  expiry: string;
  service: IntegrationService;
}
